import { render, staticRenderFns } from "./OrderPaymentsHitoryList.vue?vue&type=template&id=7dd6377a&scoped=true&"
import script from "./OrderPaymentsHitoryList.vue?vue&type=script&lang=js&"
export * from "./OrderPaymentsHitoryList.vue?vue&type=script&lang=js&"
import style0 from "./OrderPaymentsHitoryList.vue?vue&type=style&index=0&id=7dd6377a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd6377a",
  null
  
)

export default component.exports